/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export default angular.module('agrolog.api.tenant', [])
    .factory('agSetupSettingsService', SetupSettingsService)
    .name;

/*@ngInject*/
function SetupSettingsService($http, $q) {

    var service = {
        addSetupSettings: addSetupSettings,
        getSetupSettings: getSetupSettings,
        getCustomerBilling: getCustomerBilling
    }

    return service;

    function addSetupSettings(setupSettings) {
        var deferred = $q.defer();
        var url = '/api/customer/setup';
        $http.post(url, setupSettings).then(
            function success() {
                deferred.resolve();
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getSetupSettings(assetId) {
        var deferred = $q.defer();
        var url = '/api/customer/setup/' + assetId;
        $http.get(url, null).then(
            function success(response) {
                deferred.resolve(response.data);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function getCustomerBilling(customerId) {
        var deferred = $q.defer();
        var url = '/api/tenant/license/' + customerId;
        $http.get(url, null).then(
            function success(response) {
                deferred.resolve(response.data);
            },
            function fail() {
                deferred.reject();
            }
        );
        return deferred.promise;
    }
}
